import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { ApClassTypeOverrideDTOBase } from "./ApClassTypeOverrideDTOBase";
import type { ApClassTypeStaff } from "./ApClassTypeStaff";
import type { EligibilityType } from "./EligibilityType";
import type { PersonStaff } from "./PersonStaff";
import type { TrackedBase } from "./TrackedBase";

export class ApClassTypeOverrideStaff implements ApClassTypeOverrideDTOBase, TrackedBase {
  constructor(public readonly rowId: number, public readonly personId: PersonStaff | null, public readonly typeId: ApClassTypeStaff | null, public readonly season: number, public readonly overrideType: EligibilityType, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
    this.typeIdLoaded = this.typeId != null;
    this.typeIdCached = this.typeId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  private typeIdLoaded: boolean;
  private typeIdCached: ApClassTypeStaff | null;
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.apClassService().getApClassTypeOverrideStaffPersonId(this.rowId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
  async typeIdLazy(): Promise<ApClassTypeStaff> {
    if (!this.typeIdLoaded) {
      this.typeIdCached = await this.cbiServiceContext!.apClassService().getApClassTypeOverrideStaffTypeId(this.rowId);
      this.typeIdLoaded = true;
    }
    return this.typeIdCached!;
  }
}
